import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { InputWithLabel } from "../../components/micro";
import { useDispatch, useSelector } from "react-redux";
import { loginApiAdmin } from "../../redux/auth/slice";
import RippleLoader from "../../components/RippleLoader/RippleLoader";
import { Eye, EyeSlash } from "../../assets/svg";
import { Logo } from "../../assets/images";

const Auth = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const { logingDataLoading } = useSelector((store) => ({
    logingDataLoading: store?.authData?.loading,
  }));

  const handleLogin = (values) => {
    dispatch(loginApiAdmin(values)).then((res) => {
      if (res.type === "loginApiAdmin/fulfilled") {
        navigate("/");
      }
    });
  };

  return (
    <>
      <div className={`h-screen overflow-hidden relative`}>
        {logingDataLoading ? (
          <RippleLoader />
        ) : (
          <div className="flex items-center justify-center h-full bg-no-repeat bg-cover bg-center opacity-95 bg-gradient-to-r from-[rgba(255,235,79,0.5)] to-[rgba(69,160,85,0.5)]">
            <section className="w-full">
              <div className="max-w-xl w-full mx-auto">
                <div className="rounded-lg drop-shadow-lg bg-[#FFFFFFE5] px-8 py-12 mx-4">
                  <div className={"mb-8"}>
                    <div className="w-full h-full">
                      <img
                        src={Logo}
                        alt="Logo"
                        className="w-10 h-10 rounded-xl"
                      />
                    </div>
                    <div className={"mb-9"}>
                      <h4 className="text-[34px] font-Montserrat text-darkBlack font-normal mb-1">
                        Welcome!
                      </h4>
                      <p className="text-base mb-1 font-Proxima text-darkBlack font-normal ml-1">
                        To Healthy Roots
                      </p>
                    </div>
                  </div>
                  {/* Login flow */}
                  <Formik
                    initialValues={{
                      email: "",
                      password: "",
                    }}
                    validationSchema={Yup.object({
                      email: Yup.string().required("Please Enter Email"),
                      password: Yup.string()
                        .required("Please Enter Password")
                        .min(
                          8,
                          "Password is too short - should be 8 chars minimum."
                        )
                        .matches(
                          /[a-zA-Z]/,
                          "Password can only contain Latin letters."
                        ),
                    })}
                    onSubmit={(values) => {
                      handleLogin(values);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <div className="space-y-5">
                          <InputWithLabel
                            className={
                              errors.email && touched.email
                                ? `input-error`
                                : `border`
                            }
                            idFromName="email"
                            label="Email*"
                            type="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            errors={errors.email && touched.email}
                            errorsText={errors.email}
                          />

                          <div className="relative mb-1">
                            <InputWithLabel
                              className={
                                errors.password && touched.password
                                  ? `input-error`
                                  : `border`
                              }
                              idFromName="password"
                              label="Password*"
                              type={showPassword ? "text" : "password"}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.password}
                              errors={errors.password && touched.password}
                              errorsText={errors.password}
                            />
                            <button
                              type="button"
                              className="absolute right-3 top-5 transform -translate-y-1/2"
                              onClick={() => setShowPassword((prev) => !prev)}
                              tabIndex={-1}
                            >
                              {showPassword ? <Eye /> : <EyeSlash />}
                            </button>
                          </div>
                          <div className="flex items-center justify-end cursor-pointer">
                            <Link
                              to={"/reset-password"}
                              className=" font-sfPro text-base "
                            >
                              Change Password?
                            </Link>
                          </div>

                          <button
                            type="submit"
                            className="w-full block text-dark_secondary_Grey text-center text-base border-2 border-transparent bg-themeBtn text-white rounded transition uppercase duration-500 py-2 lg:px-7 px-4"
                          >
                            LogIn
                          </button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </section>
          </div>
        )}
      </div>
    </>
  );
};

export default Auth;
